

import React, { useEffect, useState } from "react";
import "./home.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import {
  FaAngleLeft,
  FaAngleRight,
} from "react-icons/fa6";
import { getPageNumbers } from "../Pagination";

const AdminHome = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [modalPage, setModalPage] = useState(1);
  const [modalTotalPages, setModalTotalPages] = useState(1);
  const [selectedAlcCode, setSelectedAlcCode] = useState("");
  const [modalType, setModalType] = useState("total");
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [programs, setPrograms] = useState([]);
  const [programCode, setProgramCode] = useState('')
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [total, setTotal] = useState([])
  const [modalFromDate, setModalFromDate] = useState("");
  const [modalToDate, setModalToDate] = useState("");
  const [modalProgramCode, setModalProgramCode] = useState("");

  const token = sessionStorage.getItem("userToken")
  const fetchData = async (pageNumber = currentPage) => {
    const backendPage = pageNumber - 1;
    setLoading(true);
    try {

      const res = await axios.get(`${BaseUrl}/api/user/dashboard`, {
        headers: {
          'Content-Type': "application/json",
          Authorization: token,
        },

      });

      if (res) {

        setData(res.data)

      }

      const resState = await axios.get(`${BaseUrl}/api/reg/registrationDto`, {
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (resState) {

        setStates(resState.data.state)
        setPrograms(resState.data.programs)
      }

      const learnerReport = await axios.get(`${BaseUrl}/api/reg/learners-report`, {
        params: {
          page: backendPage,
          size: itemsPerPage
        },
        headers: {
          'Content-Type': "application/json",
          Authorization: token,
        },

      });

      if (learnerReport) {

        setReport(learnerReport.data.content)
        setTotalPages(learnerReport.data.totalPages);
        setTotalItems(learnerReport.data.totalElements);
        setCurrentPage(pageNumber);

      }

    } catch (error) {
      console.log(error.response?.data?.message);
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {

    const token = sessionStorage.getItem("userToken");
    if (!token) {
      navigate("/login")
      return
    }
    fetchData();
  }, []);

  const handleSearch = (e) => setSearchQuery(e.target.value);

  const handleStateChange = (e) => {
    const selected = e.target.value;
    setSelectedState(selected);

  };

  const handleDistrictChange = (e) => setSelectedDistrict(e.target.value);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      fetchData(pageNumber);
    }
  };

  const handleNextPage = () => {
    handlePageChange(currentPage + 1);
  };

  const handlePreviousPage = () => {
    handlePageChange(currentPage - 1);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  const handleModalPageChange = (page) => {
    if (page >= 1 && page <= modalTotalPages) {
      fetchModalLearners(selectedAlcCode, page, modalType);
    }
  };

  const handleModalPrev = () => {
    if (modalPage > 1) {
      handleModalPageChange(modalPage - 1);
    }
  };

  const handleModalNext = () => {
    if (modalPage < modalTotalPages) {
      handleModalPageChange(modalPage + 1);
    }
  };


  const fetchModalLearners = async (alcCode, page, type = "total") => {
    try {
      const params = { page: page - 1, size: 10, alcCode };
      if (type === "active") {
        params.status = true;
      }

      const res = await axios.get(`${BaseUrl}/api/reg/learners`, {
        params,
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (res) {
        setTotal(res.data.content);
        setModalTotalPages(res.data.totalPages || 1);
        setModalPage(page);
        setIsEditing(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTotal = (alcCode) => {
    setSelectedAlcCode(alcCode);
    setModalType("total");
    fetchModalLearners(alcCode, 1, "total");
  };

  const handleActive = (alcCode) => {
    setSelectedAlcCode(alcCode);
    setModalType("active");
    fetchModalLearners(alcCode, 1, "active");
  };


  const selectDistrict = async (e) => {
    try {
      setLoading(true);
      const res = await axios.get(`${BaseUrl}/api/reg/districts`, {
        params: { stateCode: e.target.value },
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (res) {

        setDistricts(res.data)
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchFilteredReport();
  }, [searchQuery, selectedState, selectedDistrict, fromDate, toDate, programCode]);

  const fetchFilteredReport = async () => {
    if (fromDate && !toDate) {
      toast.warning("Please select 'To Date' when 'From Date' is selected.");
      return;
    }

    if (fromDate && toDate && new Date(toDate) < new Date(fromDate)) {
      toast.warning("'To Date' should be same or after 'From Date'.");
      return;
    }

    if (searchQuery && searchQuery.trim().length < 4) {
      toast.warning("Search must be at least 4 characters.");
      return;
    }

    try {
      const params = {
        page: 0,
        size: itemsPerPage,
      };

      if (searchQuery && searchQuery.trim().length >= 4) {
        params.alcCode = searchQuery.trim();
      }
      if (selectedState) {
        params.stateCode = selectedState;
      }
      if (selectedDistrict) {
        params.districtCode = selectedDistrict;
      }
      if (fromDate && toDate) {
        params.fromDate = fromDate;
        params.toDate = toDate;
      }
      if (programCode) {
        params.programCode = programCode;
      }

      const res = await axios.get(`${BaseUrl}/api/reg/learners-report`, {
        params,
        headers: {
          'Content-Type': "application/json",
          Authorization: token,
        },
      });

      if (res) {
        setReport(res.data.content || []);
        setTotalPages(res.data.totalPages);
        setTotalItems(res.data.totalElements);
        setCurrentPage(1);
      }
    } catch (error) {
      console.log("Filter fetch error:", error.response?.data?.message || error.message);
    }
  };
  const resetFilters = () => {
    setSearchQuery("");
    setSelectedState("");
    setSelectedDistrict("");
    setFromDate("");
    setToDate("");
    setProgramCode("");
    setCurrentPage(1);

    setTimeout(() => {
      fetchReportWithoutFilters();
    }, 0);
  };

  const fetchReportWithoutFilters = async () => {
    try {
      const res = await axios.get(`${BaseUrl}/api/reg/learners-report`, {
        params: {
          page: 0,
          size: itemsPerPage,
        },
        headers: {
          'Content-Type': "application/json",
          Authorization: token,
        },
      });

      if (res) {
        setReport(res.data.content || []);
        setTotalPages(res.data.totalPages);
        setTotalItems(res.data.totalElements);
        setCurrentPage(1);
      }
    } catch (error) {
      console.log("Fetch error:", error.response?.data?.message || error.message);
    }
  };

  const fetchModalFilteredLearners = async () => {
    try {
      const params = {
        page: modalPage - 1,
        size: 10,
        alcCode: selectedAlcCode,
      };

      if (modalType === "active") {
        params.status = true;
      }

      if (modalFromDate && modalToDate && new Date(modalToDate) >= new Date(modalFromDate)) {
        params.fromDate = modalFromDate;
        params.toDate = modalToDate;
      }

      if (modalProgramCode) {
        params.programCode = modalProgramCode;
      }

      const res = await axios.get(`${BaseUrl}/api/reg/learners`, {
        params,
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (res) {
        setTotal(res.data.content);
        setModalTotalPages(res.data.totalPages || 1);
      }
    } catch (error) {
      console.log("Modal filter error:", error.response?.data?.message || error.message);
    }
  };

  useEffect(() => {
    if (isEditing) {
      fetchModalFilteredLearners();
    }
  }, [modalFromDate, modalToDate, modalProgramCode, modalPage]);

  const resetModalFilters = () => {
    setModalFromDate("");
    setModalToDate("");
    setModalProgramCode("");
    setModalPage(1);

    setTimeout(() => {
      fetchModalLearners(selectedAlcCode, 1, modalType);
    }, 0);
  };





  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="home-dashboard">
          <h3 className="text-center text-uppercase text-success" style={{ fontWeight: "500" }}>
            Dashboard
          </h3>
          <div className="row">

            <div className="col-md-4">
              <div className="stat-card ">
                <h3>Total Students</h3>
                <p>{data.total || 0}</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="stat-card ">
                <h3>Total ALCs</h3>
                <p>{data?.alcs || 0}</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="stat-card">
                <h3>Active Learners</h3>
                <p>{data?.active || 0}</p>
              </div>
            </div>
            {/* <div className="col-md-3">
            <div className="stat-card">
              <h3>Total Revenue</h3>
              <p>₹ {data?.revenue || 0}</p>
            </div>
            </div> */}

          </div>

          <div className="ticket-tab mt-3">
            <div className="row mb-0">
              <div className="col-6">

                <h3>Learner's Report</h3>
              </div>


            </div>
            <hr />
            <div className="row mb-4 mx-0" style={{ "--bs-gutter-x": "0.5rem" }}>

              <div className="col-md-2 mb-2">
                <label className="text-secondary" htmlFor="search">Search ALC</label>
                <input
                  type="text"
                  id="search"
                  className="form-control"
                  placeholder="Name / Code"
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>

              <div className="col-md-2 mb-2">
                <label className="text-secondary" htmlFor="state">Select State</label>
                <select
                  id="state"
                  className="form-control"
                  value={selectedState}
                  onChange={(e) => { handleStateChange(e); selectDistrict(e) }}
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state.code} value={state.code}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2 mb-2">
                <label className="text-secondary" htmlFor="district">Select District</label>
                <select
                  id="district"
                  className="form-control"
                  value={selectedDistrict}
                  onChange={handleDistrictChange}
                >
                  <option value="">Select District</option>
                  {districts.map((district) => (
                    <option key={district.code} value={district.code}>{district.name}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-2 mb-2">
                <label className="text-secondary" htmlFor="fromDate">From Date</label>
                <input
                  type="date"
                  id="fromDate"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <div className="col-md-2 mb-2">
                <label className="text-secondary" htmlFor="toDate">To Date</label>
                <input
                  type="date"
                  id="toDate"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>

              <div className="col-md-2 mb-2">
                <label className="text-secondary" htmlFor="program">Select Program</label>
                <select
                  id="program"
                  className="form-control"
                  value={programCode}
                  onChange={(e) => setProgramCode(e.target.value)}
                >
                  <option value="">Select Program</option>
                  {programs.map((program) => (
                    <option key={program.code} value={program.code}>
                      {program.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2 my-2">
                <Button color="success" onClick={resetFilters}>
                  Reset Filters
                </Button>
              </div>


            </div>

            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>State</th>
                  <th>District</th>
                  <th>ALC Code</th>
                  <th>Alc Name</th>
                  <th>Total Learners</th>
                  <th>Active Learners</th>
                </tr>
              </thead>
              <tbody>
                {report.length > 0 ? (
                  report.map((link, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{link.state}</td>
                      <td>{link.district}</td>
                      <td>{link.alcCode}</td>
                      <td>{link.alcName}</td>
                      <td><span style={{ color: "blue", cursor: "pointer" }} onClick={() => handleTotal(link?.alcCode)}>{link.total}</span></td>
                      <td><span style={{ color: "green", cursor: "pointer" }} onClick={() => handleActive(link?.alcCode)}>{link.active}</span></td>


                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      No Data Found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="row mt-4" style={{ "--bs-gutter-x": "0rem" }}>
              <div className="col-5">
                {totalItems > 0
                  ? `Showing ${startIndex + 1}-${endIndex} of ${totalItems}`
                  : "No items to display"}
              </div>
              <div className="col-7 d-flex justify-content-end">
                <div className="d-flex align-items-center">
                  <button
                    style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                    }}
                    className="btn btn-success d-flex align-items-center justify-content-center"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    <FaAngleLeft />
                  </button>

                  <div className="mx-3 d-flex">
                    {getPageNumbers(currentPage, totalPages).map(
                      (pageNum, index) =>
                        pageNum === "..." ? (
                          <span key={`ellipsis-${index}`} className="mx-1">
                            ...
                          </span>
                        ) : (
                          <button
                            key={pageNum}
                            className={`btn mx-1 ${currentPage === pageNum
                              ? "active btn-primary"
                              : "btn-light"
                              }`}
                            onClick={() => handlePageChange(pageNum)}
                          >
                            {pageNum}
                          </button>
                        )
                    )}
                  </div>

                  <button
                    style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                    }}
                    className="btn btn-success d-flex align-items-center justify-content-center"
                    onClick={handleNextPage}
                    disabled={currentPage >= totalPages}
                  >
                    <FaAngleRight />
                  </button>
                </div>
              </div>
            </div>

          </div>

          <Modal isOpen={isEditing} toggle={() => setIsEditing(false)} centered style={{ maxWidth: '80%', width: '80%' }}>
            <ModalHeader toggle={() => setIsEditing(false)}>
              Learners List
            </ModalHeader>
            <ModalBody>

              <div className="row mb-4 mx-0">


                <div className="col-md-2 mb-2">
                  <label className="text-secondary" htmlFor="fromDate">From Date</label>
                  <input
                    type="date"
                    id="fromDate"
                    className="form-control"
                    value={modalFromDate}
                    onChange={(e) => setModalFromDate(e.target.value)}
                  />
                </div>

                <div className="col-md-2 mb-2">
                  <label className="text-secondary" htmlFor="toDate">To Date</label>
                  <input
                    type="date"
                    id="toDate"
                    className="form-control"
                    value={modalToDate}
                    onChange={(e) => setModalToDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mb-2">
                  <label className="text-secondary" htmlFor="program">Select Program</label>
                  <select
                    id="program"
                    className="form-control"
                    value={modalProgramCode}
                    onChange={(e) => setModalProgramCode(e.target.value)}
                  >
                    <option value="">Select Program</option>
                    {programs.map((program) => (
                      <option key={program.code} value={program.code}>
                        {program.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2 mt-4 ">
                  <Button color="success" onClick={resetModalFilters}>
                    Reset Filters
                  </Button>
                </div>

              </div>
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Learner Name</th>
                    <th>Program</th>
                    <th>Mobile Number</th>
                    <th>Email</th>
                    <th>Status</th>
                    <th>Enrolled On</th>
                  </tr>
                </thead>
                <tbody>
                  {total.length > 0 ? (
                    total.map((link, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{link.learnerName}</td>
                        <td>{link.program}</td>
                        <td>{link.mobileNumber}</td>
                        <td>{link.email}</td>
                        <td>{link.status ? "Active" : "Inactive"}</td>
                        <td>{new Date(link.enrolledOn).toLocaleDateString('en-GB')}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No Data Found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

            </ModalBody>

            <div className="row my-2 px-3">
              <div className="col-6">
                {total.length > 0
                  ? `Showing ${(modalPage - 1) * 10 + 1}-${(modalPage - 1) * 10 + total.length} of ${modalTotalPages * 10}`
                  : "No items to display"}
              </div>
              <div className="col-6 d-flex justify-content-end">
                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-success d-flex align-items-center justify-content-center"
                    style={{ width: "35px", height: "35px", borderRadius: "50%" }}
                    onClick={handleModalPrev}
                    disabled={modalPage === 1}
                  >
                    <FaAngleLeft />
                  </button>

                  <div className="mx-3 d-flex">
                    {getPageNumbers(modalPage, modalTotalPages).map((pageNum, idx) =>
                      pageNum === "..." ? (
                        <span key={idx} className="mx-1">...</span>
                      ) : (
                        <button
                          key={pageNum}
                          className={`btn mx-1 ${modalPage === pageNum ? "active btn-primary" : "btn-light"}`}
                          onClick={() => handleModalPageChange(pageNum)}
                        >
                          {pageNum}
                        </button>
                      )
                    )}
                  </div>

                  <button
                    className="btn btn-success d-flex align-items-center justify-content-center"
                    style={{ width: "35px", height: "35px", borderRadius: "50%" }}
                    onClick={handleModalNext}
                    disabled={modalPage >= modalTotalPages}
                  >
                    <FaAngleRight />
                  </button>
                </div>
              </div>
            </div>
            <ModalFooter className="flex-nowrap">

              <Button color="secondary" onClick={() => setIsEditing(false)}>
                Close
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
    </>
  );
};

export default AdminHome;
